import { useCallback, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../api/api';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export default function useOrgTree() {
  const [data, setData] = useState({ roots: [], orphans: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTree = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(`${API_URL}/api/org-chart/tree`, authHeaders());
      setData(res.data || { roots: [], orphans: [], total: 0 });
    } catch (e) {
      // 401/expired token → bounce to login.
      if (e?.response?.status === 401) {
        localStorage.clear();
        window.location.assign('/login');
        return;
      }
      setError(e?.response?.data?.error || e.message || 'Failed to load org chart');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTree();
  }, [fetchTree]);

  // Flat list across the whole tree (incl. orphans) for searches and filters.
  const allEmployees = useMemo(() => {
    const out = [];
    const walk = (n) => {
      out.push(n);
      (n.children || []).forEach(walk);
    };
    (data.roots || []).forEach(walk);
    (data.orphans || []).forEach((o) => out.push(o));
    return out;
  }, [data]);

  // Build set of all department names for the filter dropdown.
  const departments = useMemo(() => {
    const s = new Set();
    allEmployees.forEach((e) => {
      if (e.department) s.add(e.department);
    });
    return Array.from(s).sort();
  }, [allEmployees]);

  return { ...data, loading, error, refresh: fetchTree, allEmployees, departments };
}
